import { Injectable } from '@angular/core';

import { environment } from '@app/environment';

declare var window: any;

@Injectable({
  providedIn: 'root'
})
export class DemoozGoogleTagManagerService {
    
    constructor(
       
    ) { }
    
    init(){        
        let googleTagManagerScript = document.createElement('script');
        googleTagManagerScript.type = 'text/javascript';
        googleTagManagerScript.text = '(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({"gtm.start":new Date().getTime(),event:"gtm.js"});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!="dataLayer"?"&l="+l:"";j.async=true;j.src="https://www.googletagmanager.com/gtm.js?id="+i+dl;f.parentNode.insertBefore(j,f);})(window,document,"script","dataLayer","'+environment.GOOGLE_TAG_MANAGER_ID+'");';
        document.head.appendChild(googleTagManagerScript);
        
        let googleTagManagerNoScript = document.createElement('noscript');      
        googleTagManagerNoScript.innerHTML = '<iframe src="https://www.googletagmanager.com/ns.html?id='+environment.GOOGLE_TAG_MANAGER_ID+'" height="0" width="0" style="display:none;visibility:hidden"></iframe>';
        document.body.appendChild(googleTagManagerNoScript);
    }
    
    pushData(event: string, params?: {[key: string]: any}){        
        if(window.dataLayer){
            let data: {[key: string]: any} = {
                'event': event
            };
            if(params){
                Object.keys(params).forEach((k) => {
                    data[k] = params[k];
                });
            }
            window.dataLayer.push(data);
        }
    }
}
